import {
  FC,
  SyntheticEvent,
  ImgHTMLAttributes,
  useCallback,
  useState,
  memo,
} from 'react';
import styled from 'styled-components';

import ImagePlaceholder from '@components/loader/ImagePlaceholder';

const StyledImage = styled.img<{ $isLoaded?: boolean }>`
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: ${({ $isLoaded }) => ($isLoaded ? 1 : 0.1)};
  transition: opacity 0.3s ease-in-out;
`;

type Props = {
  onImageLoad?: (event: SyntheticEvent<HTMLImageElement>) => void;
  onImageError?: (event: SyntheticEvent<HTMLImageElement>) => void;
} & ImgHTMLAttributes<HTMLImageElement>;

const Image: FC<Props> = ({ onImageLoad, onImageError, ...props }) => {
  const [isImageLoaded, setIsImageLoaded] = useState<boolean>(false);

  const onLoad = useCallback(
    (e: SyntheticEvent<HTMLImageElement>) => {
      if (e.currentTarget.naturalWidth === 0) {
        onImageLoad?.(e);
      }

      setIsImageLoaded(true);
    },
    [onImageLoad],
  );

  const onError = useCallback(
    (e: SyntheticEvent<HTMLImageElement>) => {
      onImageError?.(e);
      setIsImageLoaded(true);
    },
    [onImageError],
  );

  return (
    <>
      {!isImageLoaded && <ImagePlaceholder />}

      <StyledImage
        onLoad={onLoad}
        onError={onError}
        loading='lazy'
        draggable='false'
        $isLoaded={isImageLoaded}
        {...props}
      />
    </>
  );
};

export default memo(Image);
